const doc = [({"da":({"js":({"admin":({"competitions":({"surveys":({"add_surveys":"Tilføj spørgeskemaer...", "the_survey_was_added":"Spørgeskemaet blev tilføjet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;